import type { MeResponse } from '@lyra/shared';

export type GuardKind = 'auth' | 'admin' | 'operator';
export type GuardResult = { ok: true } | { redirect: string };

/** Pure decision: given the required guard and the current /me context
 *  (`undefined` = not authenticated), where should the router send the user? */
export function resolveGuard(kind: GuardKind, me: MeResponse | undefined): GuardResult {
  if (!me) return { redirect: '/login' };
  if (kind === 'admin' && !(me.orgRole === 'owner' || me.orgRole === 'admin')) return { redirect: '/' };
  if (kind === 'operator' && me.globalRole !== 'platform_admin') return { redirect: '/' };
  return { ok: true };
}
